var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8783 17.0001L33.611 2.26732C34.1297 1.74862 34.1297 0.907655 33.611 0.389024C33.0923 -0.129608 32.2513 -0.129675 31.7327 0.389024L17 15.1218L2.26732 0.389024C1.74862 -0.129675 0.907655 -0.129675 0.389024 0.389024C-0.129608 0.907722 -0.129675 1.74869 0.389024 2.26732L15.1217 17L0.389024 31.7327C-0.129675 32.2514 -0.129675 33.0924 0.389024 33.611C0.512227 33.7345 0.658624 33.8325 0.8198 33.8992C0.980977 33.966 1.15375 34.0002 1.32821 34C1.50265 34.0002 1.67543 33.9659 1.83661 33.8992C1.99778 33.8324 2.14418 33.7345 2.26739 33.611L17 18.8783L31.7326 33.611C31.992 33.8703 32.3319 34 32.6718 34C33.0118 34 33.3516 33.8703 33.611 33.611C34.1297 33.0923 34.1297 32.2513 33.611 31.7327L18.8783 17.0001Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cf3b48a250fe2e8a94d89e0bf7edf199.svg";
export { ForwardRef as ReactComponent };